import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import {
  advanceLableInitialValue,
} from 'components/organisms/forms/advance/advanceLabelForm';
import { useHasPermission } from 'hooks';
import { useCustomParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetAdvanceDetail, useUpdateAdvance } from 'services/advance';
import { useGetSettlementLightList } from 'services/settlementPeriods';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

export const contractTemplateFormInitialStatus = {
  description: '',
  amount: '',
  maximumRepaymentPercentage: '',
  forSignature: false,
  repaymentsFromAllContracts: false,
  contracts: [],
  new: '',
  statusId: false,
};

const EditAdvance = () => {
  const { t } = useTranslation();
  const hasPermission = useHasPermission();
  const labelId = useCustomParamId('id', '/label');
  const advanceId = useCustomParamId('advanceId', '/label');

  const navigate = useNavigate();

  const backPathname = `/label/${labelId}/advance/${advanceId}/repayments`;
  
  const advance = useGetAdvanceDetail(advanceId);
  const editAdvance = useUpdateAdvance();
  const settlementPeriods = useGetSettlementLightList();

  const findSettlementPeriodId = (name: string, year: number) => {
    if (!settlementPeriods.data) return '';
    
    const period = settlementPeriods.data
      .flat()
      .find(p => p.settlementPeriodName.name === name && p.settlementPeriodName.year === year);
    
    return period?.id || '';
  };

  const transformedData = advance.data
    ? {
        ...middleware.advance.queryToForm(advance.data),
        statusId: advance.data.forSignature,
        settlementPeriodId: advance.data.settlementPeriod
          ? findSettlementPeriodId(advance.data.settlementPeriod.name, advance.data.settlementPeriod.year)
          : '',
      }
    : advanceLableInitialValue;

  const onEditAdvance = async (values: any) => {
    const { contracts, statusId } = values;

    const getConstracts = contracts?.map((contract: any) => contract.id);

    const advanceEdit = {
      advanceId: advanceId,
      version: advance.data?.version ?? 0,
      labelId: labelId,
      amount: values.amount,
      maximumRepaymentPercentage: values.maximumRepaymentPercentage,
      description: values.description,
      forSignature: statusId,
      repaymentsFromAllContracts: values.repaymentsFromAllContracts,
      contracts: getConstracts === undefined ? [] : getConstracts,
      settlementPeriodId: values.settlementPeriodId,
    };

    await editAdvance.mutateAsync(advanceEdit, {
      onSuccess: async () => {
        navigate(`/label/${labelId}/advance/${advanceId}/repayments`);
      },
    });
  };

  return (
    <Form.AdvanceLabelForm
    backPath={backPathname}   
      status={{ 
        displayMode: false,
        isLoading: advance.isLoading,
        refetch: advance.refetch,
      }}
      customBackItem={
        <Button onlyIcon onClick={() => navigate(backPathname)}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <>
          {hasPermission('AdvancePermissionsLIST**', 1) && (
            <Button type='submit' variant={BUTTON_VARIANT.submit}>
              <Button.Text text={t(`button.save`)} />
            </Button>
          )}
        </>
      }
      initialStatus={contractTemplateFormInitialStatus}
      initialValues={transformedData}
      onSubmit={onEditAdvance}
      disableTabs={[]}
    />
  );
};

export default EditAdvance;
